<template>
  <v-card outlined class="carousel-card">
    <v-carousel
      hide-delimiter-background
      hide-delimiters
      continuous
      :height="aHeight"
    >
      <v-carousel-item
        v-for="(slide, i) in images"
        :key="i"
        :src="slide"
      ></v-carousel-item>
    </v-carousel>
  </v-card>
</template>

<script>
export default {
  name: "Carousel",
  props: ["images", "height"],
  components: {},
  data: () => ({
    aHeight: 200,
  }),

  beforeMount() {
    if (this.height) this.aHeight = this.height;
  },
};
</script>

<style scoped>
.carousel-card {
  width: 100%;
}
</style>
